import { Typography } from "@circle-react-shared/uikit/Typography";

import type { TitleProps } from "./types";

export const OfferPage = ({ prefix, oldTitle, title, suffix }: TitleProps) => (
  <span className="inline-flex items-baseline whitespace-nowrap">
    {prefix && (
      <span className="pr-1">
        <Typography.LabelSm as="span" weight="normal">
          {prefix}
        </Typography.LabelSm>
      </span>
    )}
    <span className="inline-flex items-center align-middle">
      {oldTitle && (
        <Typography.BodyMd weight="normal">
          <span
            className="text-secondary pr-1 line-through"
            data-testid="old-price"
          >
            {oldTitle}
          </span>
        </Typography.BodyMd>
      )}
      <Typography.LabelMd weight="semibold" data-testid="current-price">
        {title}
      </Typography.LabelMd>
    </span>
    {suffix && (
      <span className="pl-1">
        <Typography.LabelSm as="span" weight="normal">
          {suffix}
        </Typography.LabelSm>
      </span>
    )}
  </span>
);
